// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"a779b129","246":"c2d00338","651":"9f5dd772","784":"e6fd747f","863":"61a5a69d"}[chunkId] + ".chunk.css";
};